async function init() {
    try {
        const response = await fetch(`${WORKER_BASE_URL}/config`);
        const data = await response.json();

        if (data.success) {
            const expired = data?.config?.features?.expired
            if (expired && expired !== "-") {
                const expiredPopup = document.getElementById('trial-expired-overlay');

                if (expiredPopup) {
                    const now = new Date()
                    if (now >= new Date(expired)) {
                        expiredPopup.style.display = 'flex';
                        document.documentElement.style.overflow = 'hidden';
                        document.body.style.overflow = 'hidden';
                    } else {
                        expiredPopup.style.display = 'none';
                    }
                }
            }
        }
    } catch (error) {
        console.error("Failed to load global config:", error);
    }
}

document.addEventListener("DOMContentLoaded", async () => {
    init();
});
